Promise.series = tasks => {
  let result = Promise.resolve();
  tasks.forEach(task => {
    // console.log('Task: ', task);
    result = result.then(() => {
      if (task instanceof Promise) {
        return task;
      } else if (typeof task === 'function') {
        return task();
      }
    });
  });
  return result;
};